import { IconAlertTriangle } from "@tabler/icons-react";
import { Alert, Group, Stack, Text } from "@/components/ui";
import type { ReglaError } from "@/lib/types";
import {
  SolicitarAltaCatalogo,
  type TipoCatalogoSolicitud,
} from "@/features/solicitudes-catalogo/components/SolicitarAltaCatalogo";

/** Alerta roja con la lista de reglas RN1-RN10 rechazadas. */
export function ReglasRechazadasAlert({
  errores,
  solicitudId,
  numeroSolicitud,
}: {
  errores: ReglaError[];
  solicitudId?: string;
  numeroSolicitud?: number;
}) {
  if (errores.length === 0) return null;
  return (
    <Alert variant="error" icon={<IconAlertTriangle size={18} />} title="Reglas rechazadas">
      <Stack gap="xs" className="mt-1.5">
        {errores.map((e, i) => (
          <Stack key={`${e.codigo}-${i}`} gap={4}>
            <Group align="flex-start" gap="xs" wrap="nowrap">
              <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[10px] text-peligro-600">
                {e.codigo}
              </code>
              <Text size="sm">{e.mensaje}</Text>
            </Group>
            {/* D-10 · el rechazo se resuelve dando de alta un elemento de catálogo. */}
            {e.catalogoFaltanteTipo && e.catalogoFaltanteClave && (
              <SolicitarAltaCatalogo
                tipo={e.catalogoFaltanteTipo as TipoCatalogoSolicitud}
                clave={e.catalogoFaltanteClave}
                solicitudPagoId={solicitudId}
                numeroSolicitudPago={numeroSolicitud}
              />
            )}
          </Stack>
        ))}
      </Stack>
    </Alert>
  );
}
